<template>
  <card title="Text Element" :element="element">
    <e-name :element="element"></e-name>
    <e-text :element="element"></e-text>
    <e-color :element="element" :full="true"></e-color>
    <e-hyper-link :element="element"></e-hyper-link>
    <e-position-group :element="element"></e-position-group>
    <e-size-group :element="element"></e-size-group>
    <e-transition-group :element="element"></e-transition-group>
    <e-visibility-group :element="element"></e-visibility-group>
    <e-pin :element="element"></e-pin>
  </card>
</template>

<script>
// import Component from "../component_location"
import Card from "./Card.vue";
import EColor from "./EColor.vue";
import EName from "./EName.vue";
import EText from "./EText.vue";
import EBackgroundOpacity from "./EBackgroundOpacity";
import EPositionGroup from "./EPositionGroup";
import ESizeGroup from "./ESizeGroup";
import ETransitionGroup from "./ETransitionGroup";
import EVisibilityGroup from "./EVisibilityGroup";
import EPin from "./EPin";
import EHyperLink from "./EHyperLink";

export default {
  components: {
    Card,
    EName,
    EText,
    EColor,
    EBackgroundOpacity,
    EPositionGroup,
    ESizeGroup,
    ETransitionGroup,
    EVisibilityGroup,
    EPin,
    EHyperLink,
  },

  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
